import { bool, func, number, object } from "prop-types";
import React, { useState } from "react";

import FnrSlides from "UI/FnrSlides";

import ProfileFieldTab from "./ProfileFieldTab";
import SacramentFields from "./SacramentFields";
import SacramentsList from "./SacramentsList";

export const keys = {
  PROFILE_FIELD: "profileField",
  SACRAMENTS: "sacraments",
  SACRAMENT_FIELDS: "sacramentFields",
};

ProfileFieldsAndSacraments.propTypes = {
  orderBy: number,
  newColumnLoading: bool,
  setNewColumnLoading: func,
  setCurrentTab: func,
  setShowPopover: func,
  setSelectedSacrament: func,
  boardID: number,
  selectedSacrament: object,
};

export default function ProfileFieldsAndSacraments({
  orderBy,
  newColumnLoading,
  setNewColumnLoading,
  setShowPopover,
  setCurrentTab,
  setSelectedSacrament,
  boardID,
  selectedSacrament,
}) {
  const [activeKey, setActiveKey] = useState(keys.PROFILE_FIELD);
  return (
    <FnrSlides
      activeKey={activeKey}
      fullWidth={true}
      components={[
        {
          key: keys.PROFILE_FIELD,
          value: () => (
            <ProfileFieldTab
              orderBy={orderBy}
              newColumnLoading={newColumnLoading}
              setNewColumnLoading={setNewColumnLoading}
              setShowPopover={setShowPopover}
              setCurrentTab={setCurrentTab}
              setActiveKey={setActiveKey}
            />
          ),
        },
        {
          key: keys.SACRAMENTS,
          value: () => (
            <SacramentsList
              setSelectedSacrament={setSelectedSacrament}
              boardID={boardID}
              setActiveKey={setActiveKey}
            />
          ),
        },
        {
          key: keys.SACRAMENT_FIELDS,
          value: () => (
            <SacramentFields
              sacrament={selectedSacrament}
              setSelectedSacrament={setSelectedSacrament}
              boardID={boardID}
              orderBy={orderBy}
              setShowPopover={setShowPopover}
              setActiveKey={setActiveKey}
            />
          ),
        },
      ]}
    />
  );
}
